import axios from 'axios';
import { baseURL } from '../api/api';
import { IRecipe } from '../api/IRecipe';

interface SearchRecipeParams {
  keyword: string;
  published?: boolean;
}

interface SearchRecipeResponse {
  recipes: IRecipe[];
  next: string;
}

export const searchRecipes = async (
  params: SearchRecipeParams
): Promise<SearchRecipeResponse> => {
  const response = await axios.get(`${baseURL}/v1/search`, {
    params: {
      keyword: params.keyword,
      published: params.published !== undefined ? params.published : true
    }
  });
  return response.data;
};
